export default __webpack_public_path__ + "static/B0180-8c7a59ca88f2845eb88737838893db91.png";